import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import NavBarMenu from "@/modules/vue/components/NavBarMenu.vue";
import NavBarMenuItem from "@/modules/vue/components/NavBarMenuItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarMenu',
  setup(__props) {
    const route = useRoute();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(NavBarMenu, null, {
        default: _withCtx(() => [_createVNode(NavBarMenuItem, {
          to: {
            name: 'transfer-market.index',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.ArrowsHorizontal,
          label: _ctx.$t('transfer_market')
        }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
          to: {
            name: 'transfer-market.listings.index',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.ClipboardSettings20Regular,
          label: _ctx.$t('my_listings')
        }, null, 8, ["to", "icon", "label"]), _createVNode(NavBarMenuItem, {
          to: {
            name: 'transfer-market.team-offers.index',
            params: _unref(route).params
          },
          icon: _ctx.IconEnum.EuroFilled,
          label: _ctx.$t('offers')
        }, null, 8, ["to", "icon", "label"])]),
        _: 1
      });
    };
  }
});